import type { Documentation_PageMetadataKey } from '@tyro/api';

export type PageMetadataRow = {
  blockId?: string | null;
  key: Documentation_PageMetadataKey;
  value: string;
};

export function getPageMetaValue(
  metadata: PageMetadataRow[] | undefined,
  key: Documentation_PageMetadataKey,
): string | undefined {
  return (metadata ?? []).find((item) => !item.blockId && item.key === key)
    ?.value;
}

export function getPageMetaValues(
  metadata: PageMetadataRow[] | undefined,
  key: Documentation_PageMetadataKey,
): string[] {
  return (metadata ?? [])
    .filter((item) => !item.blockId && item.key === key)
    .map((item) => item.value);
}
